import React from 'react';
import styled from 'styled-components';
import { Course, Lesson } from '@fenderdigital/api-definitions/play';
import Spacer from '@fenderdigital/ui/Spacer';
import Flex from '@fenderdigital/ui/Flex';
import LockIcon from '@fenderdigital/ui/Icons/Lock';
import MarkComplete from './MarkCompleteButton';
import FavoriteButton from './FavoriteButton';
import { MarkCompleteData } from '../MarkComplete/MarkComplete';

interface CardMenuProps {
  courseData?: Course;
  lessonData?: Lesson;
  onlyIcons?: boolean;
  markCompleteData?: MarkCompleteData;
  courseId?: string;
  testId: string;
  isCourse?: boolean;
  isTransparent?: boolean;
  justify?: string;
  isSong?: boolean;
  isAvailable?: boolean;
  isCourseHeader?: boolean;
}

export const LockContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardMenu: React.FC<CardMenuProps> = ({
  courseData,
  lessonData,
  onlyIcons,
  markCompleteData,
  courseId,
  testId,
  isCourse = false,
  justify = 'flex-start',
  isSong,
  isAvailable = true,
  isCourseHeader,
}) => {
  return (
    <Flex align="center" justify={justify}>
      {isAvailable ? (
        <>
          <FavoriteButton
            courseData={courseData}
            lessonData={lessonData}
            isCourse={isCourse}
            isSong={isSong}
            testId={testId}
          />
          <Spacer spacing={['md1', 'md2', 'md4']} direction="vertical" />
          <MarkComplete
            courseData={courseData}
            lessonData={lessonData}
            onlyIcons={onlyIcons}
            markCompleteData={markCompleteData}
            courseId={courseId}
            testId={testId}
            isCourseHeader={isCourseHeader}
            isSong={isSong}
          />
        </>
      ) : (
        <LockContainer>
          <LockIcon style={{ marginTop: '8px' }} aria-label="Lock" data-id="locked-content" />
        </LockContainer>
      )}
    </Flex>
  );
};

export default CardMenu;
